"use client"

import { useSyncExternalStore } from "react"

type OverviewTheme = "light" | "dark"
function subscribeTheme(listener: () => void) {
  const observer = new MutationObserver(listener)
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] })
  return () => observer.disconnect()
}
function readTheme(): OverviewTheme {
  return document.documentElement.classList.contains("dark") ? "dark" : "light"
}
export function useOverviewTheme() {
  return useSyncExternalStore<OverviewTheme>(subscribeTheme, readTheme, () => "light")
}
